import type { Lead } from '@up2stay/up2promo-api-client';

import {
  eventNamesFromLead,
  resolveEventDisplayName,
} from '@/core/lib/lead-event-names';

export type LeadCardLabelMaps = {
  /** Event id → display name */
  eventNameById?: ReadonlyMap<string, string>;
  /** Lowercase Event auto-tags to hide from the Tags row (avoid duplicating Events). */
  excludeTagKeys?: ReadonlySet<string>;
};

export function getLeadCardLabelChips(
  lead: Lead,
  maps: LeadCardLabelMaps = {},
): { events: string[]; tags: string[] } {
  const events: string[] = [];
  const seenEvents = new Set<string>();
  const extraNames = eventNamesFromLead(lead);
  for (const id of lead.eventIds ?? []) {
    const name = resolveEventDisplayName(id, maps.eventNameById ?? new Map(), {
      storedName: extraNames[id] ?? extraNames[id.trim().toLowerCase()],
      fallbackToId: false,
    });
    if (!name) continue;
    const key = name.toLowerCase();
    if (seenEvents.has(key)) continue;
    seenEvents.add(key);
    events.push(name);
  }

  const exclude = maps.excludeTagKeys ?? new Set<string>();
  const tags: string[] = [];
  const seenTags = new Set<string>();
  for (const raw of lead.tags ?? []) {
    const tag = String(raw ?? '').trim();
    if (!tag) continue;
    const key = tag.toLowerCase();
    if (exclude.has(key) || seenTags.has(key)) continue;
    seenTags.add(key);
    tags.push(tag);
  }

  return { events, tags };
}
